import React from 'react';

const UsageIcon = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.0001 23.6666C8.98617 23.6666 6.37089 22.6652 4.15422 20.6624C1.93756 18.6597 0.68339 16.161 0.391724 13.1666H2.75422C3.04589 15.5194 4.07158 17.4687 5.83131 19.0145C7.59103 20.5603 9.64728 21.3333 12.0001 21.3333C14.6056 21.3333 16.8126 20.4291 18.6209 18.6208C20.4292 16.8124 21.3334 14.6055 21.3334 11.9999C21.3334 9.39437 20.4292 7.18743 18.6209 5.37909C16.8126 3.57076 14.6056 2.66659 12.0001 2.66659C10.3278 2.66659 8.77714 3.07979 7.34797 3.90618C5.91881 4.73257 4.78617 5.87493 3.95006 7.33326H7.33339V9.66659H0.566724C1.13061 6.94437 2.482 4.70826 4.62089 2.95826C6.75978 1.20826 9.2195 0.33326 12.0001 0.33326C13.6139 0.33326 15.1306 0.63951 16.5501 1.25201C17.9695 1.86451 19.2042 2.69576 20.2542 3.74576C21.3042 4.79576 22.1355 6.03048 22.748 7.44993C23.3605 8.86937 23.6667 10.386 23.6667 11.9999C23.6667 13.6138 23.3605 15.1305 22.748 16.5499C22.1355 17.9694 21.3042 19.2041 20.2542 20.2541C19.2042 21.3041 17.9695 22.1353 16.5501 22.7478C15.1306 23.3603 13.6139 23.6666 12.0001 23.6666ZM15.2667 16.8999L10.8334 12.4666V6.16659H13.1667V11.5333L16.9001 15.2666L15.2667 16.8999Z"
      fill="currentColor"
    />
  </svg>
);

export default UsageIcon;
